/**
 * コンパイル・実行の前後で呼ばれるイベントを管理するクラス
 */
export class NakoEventEmitter {
    constructor() {
        this.eventList = [];
    }
    /**
     * イベントを登録する
     * @param eventName イベント名
     * @param callback コールバック関数
     */
    on(eventName, callback) {
        this.eventList.push({ eventName, callback });
    }
    /**
     * 指定したイベントに登録されたコールバックをすべて呼び出す
     * @param eventName イベント名
     * @param event コールバックに渡す値
     */
    fire(eventName, event) {
        const list = this.eventList.slice();
        for (const e of list) {
            if (e.eventName === eventName) {
                e.callback(event);
            }
        }
    }
    /** 登録されているイベントの一覧を返す */
    getEventList() {
        return this.eventList;
    }
    /** 登録されているイベントをすべて削除する */
    clear() {
        this.eventList = [];
    }
}
